import theme from 'antd/es/theme';
import styled from 'styled-components';

import NavMenu from './NavMenu';

const Container = styled.div<{
  $backgroundColor: string;
  $borderRadius: number;
}>`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  align-items: center;
  gap: 1rem;
  justify-content: space-between;
  background-color: ${(props) => props.$backgroundColor};
  padding: 1rem 0.5rem;
`;

const SideBar = ({
  collapsed,
  setCollapsed,
}: {
  collapsed: boolean;
  setCollapsed: (value: boolean | ((prev: boolean) => boolean)) => void;
}) => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  return (
    <Container
      $backgroundColor={colorBgContainer}
      $borderRadius={borderRadiusLG}
    >
      <NavMenu collapsed={collapsed} setCollapsed={setCollapsed} />
    </Container>
  );
};

export default SideBar;
